import { type QueryKey } from "@tanstack/react-query";

import { EntityType } from "./query-keys";

/**
 * Extract the entity key from a QueryKey.
 *
 * @param queryKey QueryKey
 * @returns EntityType
 *
 * getEntityKey(['statuses', 'detail', 123])
 * # => 'statuses'
 */
function getEntityKey(queryKey: QueryKey): EntityType {
  return queryKey[0] as EntityType;
}

export { getEntityKey };
